import React from 'react';

export const fromRenderProps =
  (RenderPropsComponent, propsMapper, renderPropName = 'children') =>
  (BaseComponent) => {
    const FromRenderProps = (ownerProps) =>
      React.createElement(RenderPropsComponent, {
        [renderPropName]: (...props) =>
          React.createElement(BaseComponent, { ...ownerProps, ...propsMapper(...props) }),
      });

    return FromRenderProps;
  };
